'use client';

import { DeviceOrientation } from '@/lib/types/device';

export const getDeviceOrientation = (): DeviceOrientation => {
    return window.matchMedia('(orientation: portrait)').matches
        ? DeviceOrientation.PORTRAIT
        : DeviceOrientation.LANDSCAPE;
};

export const isLandscape = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }
    return window.matchMedia('(orientation: landscape)').matches;
};
